import { render } from "./CustomerDialogHeader.vue?vue&type=template&id=1a9d1a4c&scoped=true"
import script from "./CustomerDialogHeader.vue?vue&type=script&lang=js"
export * from "./CustomerDialogHeader.vue?vue&type=script&lang=js"

import "./CustomerDialogHeader.vue?vue&type=style&index=0&id=1a9d1a4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9d1a4c"]])

export default __exports__